import type { ReactElement, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

type Props = {
  href: string;
  reload?: boolean;
  onClick?: () => void;
  'data-cy'?: string;
  isDisabled?: boolean;
  children: ReactNode;
};

function Link({
  href,
  reload = false,
  onClick,
  'data-cy': dataCy = '',
  isDisabled = false,
  children,
}: Props): ReactElement {
  if (isDisabled) {
    return (
      <li>
        <span className="c-nav-offcanvas__link is-disabled">
          {children}
        </span>
      </li>
    );
  }

  return (
    <li>
      {reload ? (
        <a
          className="c-nav-offcanvas__link"
          data-cy={dataCy}
          href={href}
          onClick={onClick}
        >
          {children}
        </a>
      ) : (
        <NavLink
          className={({ isActive }) => ([
            'c-nav-offcanvas__link',
            isActive ? 'is-active' : '',
          ].join(' '))}
          data-cy={dataCy}
          onClick={onClick}
          to={href}
        >
          {children}
        </NavLink>
      )}
    </li>
  );
}

export default Link;
